const OptionsCategories = () => import("Application/modules/configuration/options/views/OptionsCategories");
const OptionsCategoriesForm = () => import("Application/modules/configuration/options/views/OptionsCategoriesForm");

export default {
    children: [
        {
            path: "configuration/options",
            name: "options_categories",
            component: OptionsCategories,
            meta: {
                requiresAuth: true,
                title: "lang.options_categories",
                restrict_by_login_type: [
                    "employee",
                    "customer_support",
                    "administrator",
                    "developer",
                    "csr",
                    "producer",
                    "dispatcher",
                    "technician",
                    "driver",
                    "dispenser_mgr",
                    "customer_readonly",
                    "customer",
                ],
                restrict_by_permission: ["configuration.read"],
            },
        },
        {
            path: "configuration/options/:id?",
            name: "options_category",
            component: OptionsCategoriesForm,
            meta: {
                requiresAuth: true,
                title: "lang.options_categories",
                restrict_by_login_type: [
                    "employee",
                    "customer_support",
                    "administrator",
                    "developer",
                    "csr",
                    "producer",
                    "dispatcher",
                    "technician",
                    "driver",
                    "dispenser_mgr",
                    "customer_readonly",
                    "customer",
                ],
                restrict_by_permission: ["configuration.read"],
            },
        },
    ],
};
